export interface SettingToggleProps {
  checked: boolean;
  onChange: (next: boolean) => void;
  /** Accessible name — say what the click does, not what the state is. */
  label: string;
  /** Track colour while on (default: green, the Active toggles' look). */
  onClassName?: string;
  disabled?: boolean;
}

/**
 * The pill switch the settings tables use for a row's boolean flags (Active,
 * Paid in Full, …). One component so every flag in Settings looks and behaves
 * the same, and so a new flag is a prop rather than another copy of the markup.
 */
export function SettingToggle({
  checked,
  onChange,
  label,
  onClassName = 'bg-green-500',
  disabled,
}: SettingToggleProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={`inline-block w-8 h-4 rounded-full relative transition-colors disabled:opacity-50 ${
        checked ? onClassName : 'bg-gray-300'
      }`}
    >
      <span
        className={`absolute top-0.5 w-3 h-3 bg-white rounded-full transition-transform ${
          checked ? 'left-4' : 'left-0.5'
        }`}
      />
    </button>
  );
}
